import React, { useState, useEffect, useRef } from "react";
import { MdCheckBoxOutlineBlank } from "react-icons/md";
import { IoMdCheckboxOutline } from "react-icons/io";
import axios from "axios";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import useToast from "./useToast";
import "./styles.css";
import SubmitButton from "./submit-button";

export default function WaterfallGridDemo() {
  const { addToast, Toast } = useToast();
  const [activity, setActivity] = useState(null);
  const [option, setOption] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [ajaxing, setAjaxing] = useState(false);
  const [success, setSuccess] = useState(false);
  const [hasVoted, setHasVoted] = useState(false);
  const [noOption, setNoOption] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const voted_id = searchParams.get("id");
  let t = useRef(null);

  const [fpHash, setFpHash] = React.useState('');

  const getFp = async () => {
    const fp = await FingerprintJS.load();

    const { visitorId } = await fp.get();

    setFpHash(visitorId);
    return visitorId;
  };

  const getActivityOptions = (fp) => {
    if (!voted_id) {
      addToast("投票链接无效", "error")
      return;
    }
    setAjaxing(true);
    axios.post("/api/vote/vote_info", { voted_id: voted_id }).then(async (resVoteInfo) => {
      const options = resVoteInfo.data.options || [];
      if (options.length !== 1) {
        setNoOption(true);
        return;
      }
      const resHasVoted = await axios.post("/api/vote/has_voted", { voted_id: voted_id, option_id: options[0].id, wechat_id: fp })
      setNoOption(false);
      setActivity(resVoteInfo.data.activity || null);
      setOption(options[0]);
      const hasVoted = resHasVoted.data.hasVoted;
      if (hasVoted) {
        setSelectedOption(options[0]);
      } else {
        setSuccess(false);
      }
      setHasVoted(hasVoted);
    }).finally(() => {
      setAjaxing(false);
      setLoaded(true);
    });
  }

  const init = async () => {
    setAjaxing(true);
    const fp = await getFp();
    setAjaxing(false);
    await getActivityOptions(fp);
    await getNewOption(fp);
  }

  useEffect(() => {
    init();
    return () => {
      clearTimeout(t.current);
      t.current = null;
    }
  }, []);

  const selectVotedOption = () => {
    console.log("selectVotedOption", selectedOption)
    if (hasVoted) {
      return;
    }
    if (selectedOption) {
      setSelectedOption(null);
      return;
    }
    setSelectedOption(option);
  }

  const getNewOption = async (fp) => {
    clearTimeout(t.current);
    t.current = setTimeout(() => {
      axios.post("/api/vote/vote_info", { voted_id: voted_id }).then(async (resVoteInfo) => {
        const options = resVoteInfo.data.options || [];
        if (options.length !== 1) {
          setNoOption(true);
          return;
        }
        const resHasVoted = await axios.post("/api/vote/has_voted", { voted_id: voted_id, option_id: options[0].id, wechat_id: fp })
        setNoOption(false);
        setActivity(resVoteInfo.data.activity || null);
        setOption(options[0]);
        const hasVoted = resHasVoted.data.hasVoted ? options[0] : null;
        hasVoted && setSelectedOption(options[0]);
        setHasVoted(hasVoted);
      }).finally(async () => {
        if (fpHash) {
          await getNewOption(fpHash);
          return;
        }
        const fp = await getFp();
        getNewOption(fp);
      })
    }, 5000);
    
  }

  const handleSubmitClick = () => {
    if (!selectedOption) {
      addToast("请选择一个选项", "error")
      return;
    }
    const params = {
      voted_id: voted_id,
      options: [{ id: selectedOption.id }],
      wechat_id: fpHash
    }
    setLoading(true);
    clearTimeout(t.current);
    axios.post("/api/vote/vote_create", params).then(async (res) => {
      res.data.success && addToast("投票成功", "success");
      setSuccess(true);
      await getActivityOptions(fpHash);
    }).catch((err) => {
      console.log("error", err)
      addToast("投票失败", "error")
      setSuccess(false);
    }).finally(() => {
      setLoading(false);
      getNewOption(fpHash);
    })
  }
  console.log('hasVoted || success', hasVoted, success, hasVoted || success)

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        left: "0",
        top: "0",
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <div className="activity-content">
        {ajaxing || !loaded ? (
          <div className="loading">
            <div className="loading-inner">
              <div className="loading-icon">
                <div className="spinner">
                  <div className="bubble-1"></div>
                  <div className="bubble-2"></div>
                </div>
              </div>
              <div className="loading-text">加载中...</div>
            </div>
          </div>
        ) : (
          noOption ? (
            <div className="no-option" onClick={() => init()}>
              <div className="no-option-inner">
                <div className="no-option-text">暂无进行中的项</div>
                <div className="no-option-text">点我刷新页面</div>
              </div>
            </div>
          ) :
          activity ? (
            <div>
              <div className="activity-header">
                <div className="activity-banner">
                  <img src={`/api/file/pic/${activity.img_url}`} alt={activity.title} />
                </div>
                <div className="activity-title">
                  <p className="activity-title-text">{activity.title}</p>
                  <p className="activity-title-desc">{activity.description}</p>
                </div>
              </div>
              <div className="option-card-container">
                <div className="option-card" onClick={selectVotedOption}>
                  <img src={`/api/file/pic/${option.img_url}`} alt={option.name} />
                  <div className="option-card-title">
                    <div className="option-card-name">{option.name}</div>
                    <div className="option-card-description">{option.description}</div>
                  </div>
                  <div className="option-card-count"><div>票数: </div><div>{option.voted_num}</div></div>
                  <div className={`option-card-select ${option.id === selectedOption?.id ? "selected" : ""}`}>
                    <div>{option.id === selectedOption?.id ? <IoMdCheckboxOutline />  :<MdCheckBoxOutlineBlank />}</div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="empty-content">
              <h1>暂无活动...</h1>
            </div>
          )
        )}
      </div>
      {
        noOption ? null : (
          <div
            style={{
              position: "fixed",
              bottom: "0",
              left: "0",
              width: "100%",
              height: "110px",
              backgroundColor: "white",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="option-selected-text"><span>当前选择: </span>{selectedOption ? selectedOption.name : "未选择"}</div>
            <SubmitButton onClick={handleSubmitClick} loadingState={loading} successState={hasVoted || success}>投票</SubmitButton>
          </div>
        )
      }
      <Toast />
    </div>
  );
}
